module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#rain",
      toString: function () {
        return this.url;
      }
    }